import $http from "@/plugins/axios.js";

export default {
  state: {
    walletCards: null,
    walletCard: null,
    userWalletCards: null,
    smartWalletCards: null,
  },
  getters: {
    walletCards: (state) => state.walletCards,
    walletCard: (state) => state.walletCard,
    userWalletCards: (state) => state.userWalletCards,
    smartWalletCards: (state) => state.smartWalletCards,
  },
  mutations: {
    SET_WALLET_CARDS(state, data) {
      data.data.forEach((item) => {
        item.selected = false;
      });
      state.walletCards = data;
    },
    SET_WALLET_CARD(state, data) {
      state.walletCard = data;
    },
    SET_USER_WALLET_CARDS(state, data) {
      state.userWalletCards = data;
    },
    SET_SMART_WALLET_CARDS(state, data) {
      state.smartWalletCards = data;
    },
  },
  actions: {
    async getUserWalletCards(
      { dispatch, commit },
      payload = { take: 10, page: 1, filters: {} }
    ) {
      dispatch("toggleIsLoading", true);
      try {
        let res = await $http.get(
          `/userwallet/usercard?take=${payload.take}&page=${payload.page}${
            payload.filters.startDate
              ? `&startDate=${payload.filters.startDate}`
              : ""
          }${
            payload.filters.endDate ? `&endDate=${payload.filters.endDate}` : ""
          }${payload.filters.id ? `&id=${payload.filters.id}` : ""}${
            payload.filters.email ? `&email=${payload.filters.email}` : ""
          }
          `
        );
        dispatch("toggleIsLoading", false);
        commit("SET_USER_WALLET_CARDS", res.data);
      } catch (err) {
        dispatch("toggleIsLoading", false);
        commit("SET_USER_WALLET_CARDS", null);
        // throw err;
      }
    },

    async getSmartWalletCards(
      { dispatch, commit },
      payload = { take: 10, page: 1, filters: {} }
    ) {
      dispatch("toggleIsLoading", true);
      try {
        let res = await $http.get(
          `/account/account?take=${payload.take}&page=${payload.page}${
            payload.filters.startDate
              ? `&startDate=${payload.filters.startDate}`
              : ""
          }${
            payload.filters.endDate ? `&endDate=${payload.filters.endDate}` : ""
          }${payload.filters.id ? `&id=${payload.filters.id}` : ""}${
            payload.filters.email ? `&email=${payload.filters.email}` : ""
          }
          `
        );
        dispatch("toggleIsLoading", false);
        commit("SET_SMART_WALLET_CARDS", res.data);
      } catch (err) {
        dispatch("toggleIsLoading", false);
        commit("SET_SMART_WALLET_CARDS", null);
        // throw err;
      }
    },

    async getWalletCards(
      { dispatch, commit },
      payload = { take: 10, page: 1, filters: {} }
    ) {
      dispatch("toggleIsLoading", true);
      try {
        let res = await $http.get(
          `/card?take=${payload.take}&page=${payload.page}${
            payload.filters.startDate
              ? `&startDate=${payload.filters.startDate}`
              : ""
          }${
            payload.filters.endDate ? `&endDate=${payload.filters.endDate}` : ""
          }${payload.filters.type ? `&type=${payload.filters.type}` : ""}${
            payload.filters.id ? `&id=${payload.filters.id}` : ""
          }${payload.filters.email ? `&email=${payload.filters.email}` : ""}${
            payload.filters.tier ? `&tier=${payload.filters.tier}` : ""
          }${
            payload.filters.storeName
              ? `&storeName=${payload.filters.storeName}`
              : ""
          }${payload.filters.used ? `&used=${payload.filters.used}` : ""}
          `
        );
        dispatch("toggleIsLoading", false);
        commit("SET_WALLET_CARDS", res.data);
      } catch (err) {
        dispatch("toggleIsLoading", false);
        commit("SET_WALLET_CARDS", null);
        // throw err;
      }
    },

    async getWalletCards2fa(
      { dispatch, commit },
      payload = { take: 10, page: 1, filters: {} }
    ) {
      dispatch("toggleIsLoading", true);
      try {
        let res = await $http.get(
          `/card?take=${payload.take}&page=${payload.page}${
            payload.filters.startDate
              ? `&startDate=${payload.filters.startDate}`
              : ""
          }${
            payload.filters.endDate ? `&endDate=${payload.filters.endDate}` : ""
          }${payload.filters.type ? `&type=${payload.filters.type}` : ""}${
            payload.filters.id ? `&id=${payload.filters.id}` : ""
          }${payload.filters.email ? `&email=${payload.filters.email}` : ""}${
            payload.filters.tier ? `&tier=${payload.filters.tier}` : ""
          }${
            payload.filters.storeName
              ? `&storeName=${payload.filters.storeName}`
              : ""
          }${payload.filters.used ? `&used=${payload.filters.used}` : ""}
          `
        );
        dispatch("toggleIsLoading", false);
        commit("SET_WALLET_CARDS", res.data);
      } catch (err) {
        dispatch("toggleIsLoading", false);
        commit("SET_WALLET_CARDS", null);
        // throw err;
      }
    },

    async getUsedWalletCards(
      { dispatch, commit },
      payload = { take: 10, page: 1, filters: {} }
    ) {
      dispatch("toggleIsLoading", true);
      try {
        let res = await $http.get(
          `/card?take=${payload.take}&page=${payload.page}${
            payload.filters.startDate
              ? `&startDate=${payload.filters.startDate}`
              : ""
          }${
            payload.filters.endDate ? `&endDate=${payload.filters.endDate}` : ""
          }&used=true${
            payload.filters.type ? `&type=${payload.filters.type}` : ""
          }${payload.filters.id ? `&id=${payload.filters.id}` : ""}${
            payload.filters.email ? `&email=${payload.filters.email}` : ""
          }${payload.filters.tier ? `&tier=${payload.filters.tier}` : ""}
          `
        );
        dispatch("toggleIsLoading", false);
        commit("SET_WALLET_CARDS", res.data);
      } catch (err) {
        dispatch("toggleIsLoading", false);
        commit("SET_WALLET_CARDS", null);
        // throw err;
      }
    },
    async addUserWalletCard({ dispatch, commit }, payload) {
      dispatch("toggleBtnLoading", true);
      try {
        await $http.post("/userwallet/usercard", payload);
        dispatch("pushAlert", {
          alertVariant: "success",
          alertMessage: "تم اضافة البيانات بنجاح",
          duration: 3,
        });
        dispatch("toggleBtnLoading", false);
        return commit;
      } catch (err) {
        console.error(err);
        if (
          err.response.status === 500 ||
          err.response.status === 404 ||
          err.response.status === 400
        ) {
          dispatch("pushAlert", {
            alertVariant: "danger",
            alertMessage: err.response.data.error.message,
            duration: 3,
          });
        } else {
          dispatch("pushAlert", {
            alertVariant: "danger",
            alertMessage: "خلل في الاتصال حاول مجددا",
            duration: 3,
          });
        }
        dispatch("toggleBtnLoading", false);
        throw err;
      }
    },

    async addWalletCard({ dispatch, commit }, payload) {
      dispatch("toggleBtnLoading", true);
      try {
        await $http.post("/card", payload);
        dispatch("pushAlert", {
          alertVariant: "success",
          alertMessage: "تم اضافة البيانات بنجاح",
          duration: 3,
        });
        dispatch("toggleBtnLoading", false);
        return commit;
      } catch (err) {
        console.error(err);
        if (
          err.response.status === 500 ||
          err.response.status === 404 ||
          err.response.status === 400
        ) {
          dispatch("pushAlert", {
            alertVariant: "danger",
            alertMessage: err.response.data.error.message,
            duration: 3,
          });
        } else {
          dispatch("pushAlert", {
            alertVariant: "danger",
            alertMessage: "خلل في الاتصال حاول مجددا",
            duration: 3,
          });
        }
        dispatch("toggleBtnLoading", false);
        throw err;
      }
    },
    async editUserWalletCard({ dispatch, commit }, payload) {
      dispatch("toggleBtnLoading", true);
      try {
        await $http.post(`/userwallet/usercard/${payload.id}`, {
          birthday: payload.birthday,
          email: payload.email,
          firstName: payload.firstName,
          lastName: payload.lastName,
          password: payload.password,
          phoneNumber: payload.phoneNumber,
        });
        dispatch("toggleBtnLoading", false);
        dispatch("pushAlert", {
          alertVariant: "success",
          alertMessage: "تم اضافة البيانات بنجاح",
          duration: 3,
        });
        return commit;
      } catch (err) {
        dispatch("toggleBtnLoading", false);
        if (
          err.response.status === 500 ||
          err.response.status === 404 ||
          err.response.status === 400
        ) {
          dispatch("pushAlert", {
            alertVariant: "danger",
            alertMessage: err.response.data.error.message,
            duration: 3,
          });
        } else {
          dispatch("pushAlert", {
            alertVariant: "danger",
            alertMessage: "خلل في الاتصال حاول مجددا",
            duration: 3,
          });
        }
        throw err;
      }
    },

    async editSmartWalletCard({ dispatch, commit }, payload) {
      dispatch("toggleBtnLoading", true);
      try {
        await $http.put(`/account/account/${payload.id}`, {
          birthday: payload.birthday,
          email: payload.email,
          firstName: payload.firstName,
          lastName: payload.lastName,
          password: payload.password,
          phoneNumber: payload.phoneNumber,
          notes: payload.notes,
          facebook: payload.facebook,
          instagram: payload.instagram,
          tiktok: payload.tiktok,
          telegram: payload.telegram,
          whatsapp: payload.whatsapp,
          x: payload.x,
          youtube: payload.youtube,
          linkedin: payload.linkedin,
          snapchat: payload.snapchat,
          occupation: payload.occupation,
          address: payload.address,
          description: payload.description,
        });
        dispatch("toggleBtnLoading", false);
        dispatch("pushAlert", {
          alertVariant: "success",
          alertMessage: "تم اضافة البيانات بنجاح",
          duration: 3,
        });
        return commit;
      } catch (err) {
        dispatch("toggleBtnLoading", false);
        if (
          err.response.status === 500 ||
          err.response.status === 404 ||
          err.response.status === 400
        ) {
          dispatch("pushAlert", {
            alertVariant: "danger",
            alertMessage: err.response.data.error.message,
            duration: 3,
          });
        } else {
          dispatch("pushAlert", {
            alertVariant: "danger",
            alertMessage: "خلل في الاتصال حاول مجددا",
            duration: 3,
          });
        }
        throw err;
      }
    },

    async editWalletCard({ dispatch, commit }, payload) {
      dispatch("toggleBtnLoading", true);
      try {
        await $http.patch(`/card/${payload.id}`, payload);
        dispatch("toggleBtnLoading", false);
        dispatch("pushAlert", {
          alertVariant: "success",
          alertMessage: "تم اضافة البيانات بنجاح",
          duration: 3,
        });
        return commit;
      } catch (err) {
        dispatch("toggleBtnLoading", false);
        if (
          err.response.status === 500 ||
          err.response.status === 404 ||
          err.response.status === 400
        ) {
          dispatch("pushAlert", {
            alertVariant: "danger",
            alertMessage: err.response.data.error.message,
            duration: 3,
          });
        } else {
          dispatch("pushAlert", {
            alertVariant: "danger",
            alertMessage: "خلل في الاتصال حاول مجددا",
            duration: 3,
          });
        }
        throw err;
      }
    },

    async deleteUserWalletCard({ dispatch, commit }, id) {
      dispatch("toggleBtnLoading", true);
      try {
        await $http.delete(`/userwallet/usercard/${id}`);
        dispatch("toggleBtnLoading", false);
        dispatch("pushAlert", {
          alertVariant: "success",
          alertMessage: "تم حذف البيانات بنجاح",
          duration: 3,
        });
        return commit;
      } catch (err) {
        console.error(err);
        if (
          err.response.status === 500 ||
          err.response.status === 404 ||
          err.response.status === 400
        ) {
          dispatch("pushAlert", {
            alertVariant: "danger",
            alertMessage: err.response.data.error.message,
            duration: 3,
          });
        } else {
          dispatch("pushAlert", {
            alertVariant: "danger",
            alertMessage: "خلل في الاتصال حاول مجددا",
            duration: 3,
          });
        }
        dispatch("toggleBtnLoading", false);
        return;
      }
    },

    async deleteSmartWalletCard({ dispatch, commit }, id) {
      dispatch("toggleBtnLoading", true);
      try {
        await $http.delete(`/account/account/${id}`);
        dispatch("toggleBtnLoading", false);
        dispatch("pushAlert", {
          alertVariant: "success",
          alertMessage: "تم حذف البيانات بنجاح",
          duration: 3,
        });
        return commit;
      } catch (err) {
        console.error(err);
        if (
          err.response.status === 500 ||
          err.response.status === 404 ||
          err.response.status === 400
        ) {
          dispatch("pushAlert", {
            alertVariant: "danger",
            alertMessage: err.response.data.error.message,
            duration: 3,
          });
        } else {
          dispatch("pushAlert", {
            alertVariant: "danger",
            alertMessage: "خلل في الاتصال حاول مجددا",
            duration: 3,
          });
        }
        dispatch("toggleBtnLoading", false);
        return;
      }
    },

    async deleteWalletCard({ dispatch, commit }, id) {
      dispatch("toggleBtnLoading", true);
      try {
        await $http.delete(`/card/${id}`);
        dispatch("toggleBtnLoading", false);
        dispatch("pushAlert", {
          alertVariant: "success",
          alertMessage: "تم حذف البيانات بنجاح",
          duration: 3,
        });
        return commit;
      } catch (err) {
        console.error(err);
        if (
          err.response.status === 500 ||
          err.response.status === 404 ||
          err.response.status === 400
        ) {
          dispatch("pushAlert", {
            alertVariant: "danger",
            alertMessage: err.response.data.error.message,
            duration: 3,
          });
        } else {
          dispatch("pushAlert", {
            alertVariant: "danger",
            alertMessage: "خلل في الاتصال حاول مجددا",
            duration: 3,
          });
        }
        dispatch("toggleBtnLoading", false);
        return;
      }
    },
  },
};
